/*
 * Created on Tue Jun 15 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import whiteLogo from "./assets/images/icons/white-logo-23.png";
import pinkLogo from "./assets/images/icons/pink-logo-23.png";
import greyLogo from "./assets/images/icons/grey-logo-23.png";
import React, { useState, useEffect } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { useLocation, useHistory } from "react-router-dom";

export function Navigation({ activeTab, displayAll, addClass, isPublic, loggedIn, noLogo }) {
    const { push } = useHistory()
    let location = useLocation().pathname.substring(1);
    let tabs = [
        {
            link: '/',
            label: null
        },
        {
            link: '/here/manifesto',
            label: 'manifesto'
        },
        {
            link: '/here/how-it-works',
            label: 'how it works'
        },
        {
            link: '/signup',
            label: 'sign up'
        },
        {
            link: '/login',
            label: 'log in'
        }
    ];

    // remove howitworks navigation when user is in manifesto or howitworks
    if (location !== 'here/manifesto' && !location.includes('how-it-works')) tabs.splice(2, 1);
    if (location === 'find') tabs.splice(1, 1);
    // remove itch logo navigation when user is in landing page and when noLogo is set
    if (location === '' && noLogo) tabs.splice(0, 1);
    // remove signup and login navigation when user is logged in
    if (loggedIn) {
        tabs = tabs.splice(1, 2);
        activeTab--;
    }

    const defaultLogo = !location.includes('how-it-works') ? whiteLogo : greyLogo;
    const [logo, setLogo] = useState(defaultLogo);
    const [hoveredTab, setHoveredTab] = useState(false);

    useEffect(() => {
        // set active tab as "hovered" tab
        if (!isPublic) {
            setTimeout(() => { setHoveredTab(activeTab) }, 1000);
        }
        else setHoveredTab(activeTab)
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Tabs
                className={(displayAll ? 'nav ' : 'd-none ') + (addClass ? addClass : '') + (loggedIn ? ' logged-in' : '')}
                value={hoveredTab}
                onMouseOut={() => setHoveredTab(activeTab)}
                TabIndicatorProps={{ children: <span /> }}
            >
                {tabs.map(({ link, label }, index) => (
                    <Tab
                        key={index}
                        icon={
                            // only show logo when index is 0 and when user is logged in
                            (index === 0)
                                ?
                                <>
                                    {!noLogo ?
                                        <img src={hoveredTab === index && !isPublic ? pinkLogo : logo}
                                            onMouseOver={() => !isPublic ? setLogo(`${pinkLogo}`) : null}
                                            onMouseOut={() => !isPublic ? setLogo(`${defaultLogo}`) : null}
                                            className="white-logo"
                                            alt="logo"
                                        />
                                    : null}
                                </>
                                :
                                <div className="nav-line"></div>
                        }
                        className="nav-link subpixel"
                        onClick={() => {
                            push(link)
                        }}
                        disableRipple
                        onMouseOver={() => setHoveredTab(index)}
                        label={label}
                    />
                ))}
            </Tabs>
        </>
    )
}
